export type FormatShortDate = {
  /** Numeric local date: 06/30/2026 (en) or 30/06/2026 (en-GB). */
  format: (date: Date | string | null | undefined) => string;
};

function toJsDate(date: Date | string): Date {
  if (date instanceof Date) {
    return date;
  }
  // Date-only ISO → local calendar day (avoid UTC midnight shifting the day)
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [year, month, day] = date.split('-').map(Number);
    return new Date(year, month - 1, day);
  }
  return new Date(date);
}

/**
 * Locale-aware short numeric date (day/month order from active i18n locale).
 * Maps bare `en` → `en-US` so Intl uses US month/day order.
 */
export function createFormatShortDate(locale: string): FormatShortDate {
  const intlLocale = locale === 'en' ? 'en-US' : locale;
  const formatter = new Intl.DateTimeFormat(intlLocale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  return {
    format: date => {
      if (date == null) {
        return '';
      }
      const d = toJsDate(date);
      if (Number.isNaN(d.getTime())) {
        return '';
      }
      return formatter.format(d);
    }
  };
}
